import React from 'react';
import ClientPhone from '../shared/ClientPhone';
import BootstrapTable from 'react-bootstrap-table-next';
import styles from './Faq.module.css';

const constellationData = [
    {
        interiorElectric: 'Defects in materials or workmanship',
        evCharger: 'Defects in materials or workmanship'
    },
    {
        interiorElectric: 'Normal wear & tear',
        evCharger: 'Power Surge'
    },
    {
        interiorElectric: '',
        evCharger: 'Accidental Damage from Handling'
    }
];
const constellationColumns = [
    {
        dataField: 'interiorElectric',
        text: 'Interior Electric'
    },
    {
        dataField: 'evCharger',
        text: 'EV Charger'
    }
];

const homekickBuyerColumns = [
    {
        dataField: 'homekickAsset',
        text: ''
    },
    {
        dataField: 'homekickAssetValue',
        text: ''
    }
];
const homekickBuyerData = [
    {
        homekickAsset: 'Built-in Microwave',
        homekickAssetValue: 'Ductwork'
    },
    {
        homekickAsset: 'Ceiling Fans (up to four units)',
        homekickAssetValue: 'Garage Door Opener (up to two units)'
    },
    {
        homekickAsset: 'Central Air Conditioning System (up to two units, each with maximum of 5-ton capacity)',
        homekickAssetValue: 'Garbage Disposal'
    },
    {
        homekickAsset: 'Central Home Heating System (up to two units, each with maximum of 5-ton capacity)',
        homekickAssetValue: 'Interior Electrical System'
    },
    {
        homekickAsset: 'Refrigerant (including recapture and disposal)',
        homekickAssetValue: 'Kitchen Exhaust Fan/Range Hood'
    },
    {
        homekickAsset: 'Clothes Dryer',
        homekickAssetValue: 'Plumbing Stoppages (up to 125 ft.)'
    },
    {
        homekickAsset: 'Clothes Washer',
        homekickAssetValue:
            'Plumbing System (including faucets, fixtures, toilets and repair of the following: walls, ceilings or floors to rough finish up to $1,000 per claim and subject to aggregate limit)'
    },
    {
        homekickAsset: 'Gas or Electric Cooking Appliance (covers one of the following: range, oven or cooktop)',
        homekickAssetValue: 'Refrigerator (including ice maker and food spoilage up to $300)'
    },
    {
        homekickAsset: 'Dishwasher',
        homekickAssetValue: 'Water Heater (up to 75 gallons, including failures due to sediment)'
    }
];
const homekickSellerData = [
    {
        homekickAsset: 'Built-in Microwave',
        homekickAssetValue: 'Garbage Disposal'
    },
    {
        homekickAsset: 'Ceiling Fans (up to four units)',
        homekickAssetValue: 'Interior Electrical System'
    },
    {
        homekickAsset: 'Clothes Dryer',
        homekickAssetValue: 'Kitchen Exhaust Fan/Range Hood'
    },
    {
        homekickAsset: 'Clothes Washer',
        homekickAssetValue: 'Plumbing Stoppages (up to 125 ft.)'
    },
    {
        homekickAsset: 'Gas or Electric Cooking Appliance (covers one of the following: range, oven or cooktop)',
        homekickAssetValue:
            'Plumbing System (including faucets, fixtures, toilets and repair of the following: walls, ceilings or floors to rough finish up to $1,000 per claim and subject to aggregate limit)'
    },
    {
        homekickAsset: 'Dishwasher',
        homekickAssetValue: 'Refrigerator (including ice maker and food spoilage up to $300)'
    },
    {
        homekickAsset: 'Ductwork',
        homekickAssetValue: 'Water Heater (up to 75 gallons, including failures due to sediment)'
    },
    {
        homekickAsset: 'Garage Door Opener (up to two units)',
        homekickAssetValue: ''
    }
];

const homekickDTCData = [
    {
        homekickAsset: 'Built-in Microwave',
        homekickAssetValue: 'Ductwork'
    },
    {
        homekickAsset: 'Ceiling Fans (up to four units)',
        homekickAssetValue: 'Garage Door Opener (up to two units)'
    },
    {
        homekickAsset: 'Central Air Conditioning System (up to two units, each with maximum of 5-ton capacity)',
        homekickAssetValue: 'Garbage Disposal'
    },
    {
        homekickAsset: 'Central Home Heating System (up to two units, each with maximum of 5-ton capacity)',
        homekickAssetValue: 'Interior Electrical System'
    },
    {
        homekickAsset: 'Refrigerant (including recapture and disposal)',
        homekickAssetValue: 'Kitchen Exhaust Fan/Range Hood'
    },
    {
        homekickAsset: 'Clothes Dryer',
        homekickAssetValue: 'Plumbing Stoppages (up to 125 ft.)'
    },
    {
        homekickAsset: 'Clothes Washer',
        homekickAssetValue:
            'Plumbing System (including faucets, fixtures, toilets and repair of the following: walls, ceilings or floors to rough finish up to $1,000 per claim and subject to aggregate limit)'
    },
    {
        homekickAsset: 'Gas or Electric Cooking Appliance (covers one of the following: range, oven or cooktop)',
        homekickAssetValue: 'Refrigerator (including ice maker and food spoilage up to $300)'
    },
    {
        homekickAsset: 'Dishwasher',
        homekickAssetValue: 'Water Heater (up to 75 gallons, including failures due to sediment)'
    }
];

const sureBuyerColumns = [
    {
        dataField: 'sureAsset',
        text: ''
    },
    {
        dataField: 'sureAssetValue',
        text: ''
    }
];
const sureBuyerData = [
    {
        sureAsset: 'Built-in Microwave',
        sureAssetValue: 'Ductwork'
    },
    {
        sureAsset: 'Ceiling Fans (up to four units)',
        sureAssetValue: 'Garage Door Opener (up to two units)'
    },
    {
        sureAsset: 'Central Air Conditioning System (up to two units, each with maximum of 5-ton capacity)',
        sureAssetValue: 'Garbage Disposal'
    },
    {
        sureAsset: 'Central Home Heating System (up to two units, each with maximum of 5-ton capacity)',
        sureAssetValue: 'Interior Electrical System'
    },
    {
        sureAsset: 'Refrigerant (including recapture and disposal)',
        sureAssetValue: 'Kitchen Exhaust Fan/Range Hood'
    },
    {
        sureAsset: 'Clothes Dryer',
        sureAssetValue: 'Plumbing Stoppages (up to 125 ft.)'
    },
    {
        sureAsset: 'Clothes Washer',
        sureAssetValue:
            'Plumbing System (including faucets, fixtures, toilets and repair of the following: walls, ceilings or floors to rough finish up to $1,000 per claim and subject to aggregate limit)'
    },
    {
        sureAsset: 'Gas or Electric Cooking Appliance (covers one of the following: range, oven or cooktop)',
        sureAssetValue: 'Refrigerator (including ice maker and food spoilage up to $300)'
    },
    {
        sureAsset: 'Dishwasher',
        sureAssetValue: 'Water Heater (up to 75 gallons, including failures due to sediment)'
    }
];

const sureSellerColumns = [
    {
        dataField: 'sureSellerAsset',
        text: ''
    },
    {
        dataField: 'sureSellerAssetValue',
        text: ''
    }
];
const sureSellerData = [
    {
        sureSellerAsset: 'Freezer (standalone)',
        sureSellerAssetValue: 'Humidifier'
    },
    {
        sureSellerAsset: 'Pool',
        sureSellerAssetValue: 'Ice Maker (standalone)'
    },
    {
        sureSellerAsset: 'Spa',
        sureSellerAssetValue: 'Water Heater (second unit, up to 75 gallons, including failure due to sediment)'
    },
    {
        sureSellerAsset: 'Pool and Spa Combo (shared pumps and operating equipment)',
        sureSellerAssetValue: ''
    }
];

const homekickAdditionalData = [
    {
        homekickAsset: 'Freezer (standalone)',
        homekickAssetValue: 'Humidifier'
    },
    {
        homekickAsset: 'Pool',
        homekickAssetValue: 'Ice Maker (standalone)'
    },
    {
        homekickAsset: 'Spa',
        homekickAssetValue: 'Water Heater (second unit, up to 75 gallons, including failure due to sediment)'
    },
    {
        homekickAsset: 'Pool and Spa Combo (shared pumps and operating equipment)',
        homekickAssetValue: ''
    }
];
export const brandFaqs = {
    hwa: [
        {
            title: 'default',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'Once I submit a claim, how long will it take for me to get an appointment?',
                    answer: "The service provider that will be assigned to your request will be in contact with you shortly after you file your claim to schedule an appointment at your home. Most appointments will be scheduled during normal business hours. If you do not hear from the service provider within 24 hours, we'll provide you with a number so that you can contact them directly."
                },
                {
                    question: 'When do I pay the trade call fee?',
                    answer: 'Depending on your contract, the trade call fee may be due when your service visit is scheduled or when a contractor visits your home. This will be stated clearly in your contract.'
                },
                {
                    question: 'How soon will a service technician be available to work on my claim?',
                    answer: 'HWA will dispatch service requests to an authorized contractor within 48 hours. You will then communicate directly with the contractor to arrange a mutually convenient appointment.'
                },
                {
                    question: 'What will happen when the service provider arrives at my home?',
                    answer: 'After the service provider arrives at your home, they will diagnose the problem, and if necessary, call the HWA Authorization Department to determine coverage and obtain authorization to proceed with the repair or replacement. Keep in mind, that for most repairs, the service provider will be able to complete the service request while at your home.'
                },
                {
                    question: 'How long will it take for equipment or parts to arrive?',
                    answer: "If equipment or parts are necessary to complete the repair or replacement, HWA's Purchasing Department will order the equipment."
                },
                {
                    question: 'What happens when the parts are delivered?',
                    answer: 'Once the equipment or parts are delivered, the service provider will be back in contact to schedule an appointment at your home to complete the repair or installation.'
                }
            ]
        }
    ],

    njr: [
        {
            title: 'About Service Plans',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'Why buy a Service Plan?',
                    answer: 'Over time, appliances may require service repairs or replacements. Once the manufacturer’s warranty expires, these could be unexpected and costly. A Service Plan will protect your covered essential systems and appliances when they get damaged due to normal wear and tear. With a Service Plan, if a covered incident occurs, we’ll repair or replace it.'
                },
                {
                    question:
                        'Once a Service Plan is purchased, how long will it take to receive the actual Service Plan contract?',
                    answer: 'If a valid email address is provided, we will send the Service Plan via email within five to seven business days (Monday-Friday) after purchase. If we do not have an email address, we will send the contract via United States Postal Service (USPS), within two to four weeks after purchase.'
                },
                {
                    question: 'What are the different payment options?',
                    answer: 'A Service Plan can either be paid monthly or yearly. If you choose monthly, payments will be automatically charged to the card provided every thirty (30) days. Yearly plans will automatically renew each year. Further details can be found in the terms and conditions.'
                },
                {
                    question: 'What payment methods can be used to purchase a plan?',
                    answer: 'We accept any Visa, MasterCard, Discover or American Express in the form of a credit or debit card online and over the phone for U.S. purchases.'
                },
                {
                    question: 'Can a Service Plan be purchased if the product is used in a business?',
                    answer: 'Products used in a commercial setting are not eligible for coverage. See terms and conditions for complete details.'
                }
            ]
        },
        {
            title: 'Plan Options',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'What are the coverage options?',
                    answer: 'We currently offer three plan options – Kitchen Appliance Plan, Laundry Appliance Plan and Total Appliance Plan (includes both Kitchen and Laundry Plan coverages).'
                },
                {
                    question: 'What is covered in the Kitchen Plan?',
                    answer: 'Coverage is included for: One cooking product (either a range, oven or cooktop), dishwasher, kitchen exhaust fan, garbage disposal, built-in microwave, refrigerator (does not include ice maker) and interior electrical system.'
                },
                {
                    question: 'What is covered in the Laundry Plan?',
                    answer: 'Coverage is included for one washer and one dryer.'
                },
                {
                    question: 'Can I purchase the Kitchen and Laundry Plans at the same time?',
                    answer: 'Yes, you can purchase a Total Appliance Plan which includes both the Kitchen and Laundry Plan coverages!'
                },
                {
                    question: 'Can I add on any additional appliances or products?',
                    answer: 'Yes, for an additional cost, you can add on a secondary cooking product (either a range, oven or cooktop), a secondary built-in microwave and/or a secondary refrigerator. Note: The refrigerator’s ice maker components are not covered under these plans.'
                },
                {
                    question: 'Can I cancel my Service Plan once I have purchased it?',
                    answer: 'Yes, you may cancel this Agreement at any time for any reason. You may cancel this Agreement via phone by calling 1-888-405-0602. If you cancel this Agreement within thirty (30) days from the Purchase Date without making a claim (“Free Look Period”), you will receive a refund of the full purchase.  If you cancel this Agreement post thirty (30) days from the Purchase Date and you pay annually, you will be refunded the remaining days of coverage on a monthly prorated basis, less costs for service performed and claims paid.  Monthly contracts will not generate a refund and will cancel your coverage after the current month’s coverage expires.'
                }
            ]
        },
        {
            title: 'Filing A Claim',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'When can a claim be filed?',
                    answer: 'There is a thirty (30) day WAIT PERIOD, from the date of the Service Plan purchase. Also, any pre-existing conditions or failures that occur prior to or during the wait period will not be covered. Products still covered under the manufacturer’s warranty period should be referred to the manufacturer for claim.'
                },
                {
                    question: 'How is a claim filed?',
                    answer: 'If a problem occurs, call toll-free 1-877-531-4872 and explain the issue.'
                },
                {
                    question: 'How is service scheduled?',
                    answer: 'Once the Service Plan has been activated, call 1-877-531-4872 to schedule service.'
                },
                {
                    question: 'Who will service the product?',
                    answer: 'Service will be scheduled at your convenience with an authorized technician in your area.'
                },
                {
                    question: 'If my appliance cannot be repaired, how will it be replaced?',
                    answer: "Our goal is to successfully resolve all valid claims. However, there are rare circumstances where the product is beyond repair. If this happens, under the terms of your Service Plan, we will either exchange your product with a replacement that has similar features and functionality or reimburse you. However, replacement and reimbursement will be based on the product's age and the remaining limit of liability. Per twelve (12) month period, we will cover up to $800 per appliance or system that is 10 years old or less in age at the time of the breakdown and $500 per appliance or system that is over 10 years old at the time of breakdown, not to exceed the aggregate limit stated on your Service Plan. Please see our complete terms and conditions for more details."
                }
            ]
        }
    ],
    et: [
        {
            // title: 'default',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'Do I pay a service fee when I need a repair?',
                    answer: [
                        <>
                            No! Your plan requires no service fee and has no deductibles! We pay for covered repairs up
                            to the claim limit of your plan.
                        </>
                    ]
                },
                {
                    question: 'How soon will a service technician be available to work on my claim?',
                    answer: [
                        <>
                            If we are responsible for scheduling service under your Plan and in-home service is
                            required, we will dispatch service requests to an authorized contractor within 48 hours. You
                            will then communicate directly with the contractor to arrange a mutually convenient
                            appointment.
                        </>
                    ]
                },
                {
                    question: 'How long will it take for equipment or parts to arrive?',
                    answer: [
                        <>
                            If equipment or parts are necessary to complete the repair or replacement, the equipment
                            and/or parts may be ordered by either our Purchasing Department or your Service Provider.
                            How long it will take varies by availability and region. If there is a delay or shortage
                            with your order, we will keep you posted along the way. Once the equipment or parts are
                            delivered, the designated service provider will be back in contact to schedule an
                            appointment at your home to complete the repair or installation.
                        </>
                    ]
                },
                {
                    question: 'What do I do if I have any issues along the way?',
                    answer: [
                        <>
                            Contact us to help you through the process and address your needs at <ClientPhone /> during
                            the business hours of Monday through Friday 7am to 7pm CST and Saturday 8am to 4pm CST.
                        </>
                    ]
                }
            ]
        }
    ],

    bestbuy: [
        {
            faqs: [
                {
                    question: 'Do I pay a service fee when I need a repair?',
                    answer: [
                        <>
                            No! Your plan requires no service fee and has no deductibles! We pay for covered repairs up
                            to the claim limit of your plan.
                        </>
                    ]
                },
                {
                    question: 'How soon will a service technician be available to work on my claim?',
                    answer: [
                        <>
                            If we are responsible for scheduling service under your Plan and in-home service is
                            required, we will dispatch service requests to an authorized contractor within 48 hours. You
                            will then communicate directly with the contractor to arrange a mutually convenient
                            appointment.
                        </>
                    ]
                },
                {
                    question: 'How long will it take for equipment or parts to arrive?',
                    answer: [
                        <>
                            If equipment or parts are necessary to complete the repair or replacement, the equipment
                            and/or parts may be ordered by either our Purchasing Department or your Service Provider.
                            How long it will take varies by availability and region. If there is a delay or shortage
                            with your order, we will keep you posted along the way. Once the equipment or parts are
                            delivered, the designated service provider will be back in contact to schedule an
                            appointment at your home to complete the repair or installation.
                        </>
                    ]
                },
                {
                    question: 'What do I do if I have any issues along the way?',
                    answer: [
                        <>
                            Contact us to help you through the process and address your needs at <ClientPhone /> during
                            the business hours of Monday through Friday 7am to 7pm CST and Saturday 8am to 4pm CST.
                        </>
                    ]
                }
            ]
        }
    ],
    constellation: [
        {
            title: 'About Protection Plans',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'What is a protection plan?',
                    answer: [
                        <>
                            <p>
                                A protection plan from Constellation can help with repair costs for your covered
                                Interior Electric System and Electric Vehicle Charger if a breakdown occurs. These
                                interruptions can be unexpected and may be costly. With a protection plan, if a covered
                                incident occurs, we will help repair or replace the product or component up to the
                                maximum annual benefit. Please see the{' '}
                                <a
                                    href='/coveragedocs'
                                    target='blank'
                                >
                                    terms and conditions
                                </a>{' '}
                                for complete details.
                            </p>
                        </>
                    ]
                },
                {
                    question: 'Do I pay a service fee or deductible?',
                    answer: 'No, this plan does not require a service fee or deductible to initiate a claim. It covers the cost of eligible repairs up to the plan’s maximum annual limit.'
                }
            ]
        },
        {
            title: 'Plan Options',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'What is covered by the protection plan?',
                    answer: [
                        <>
                            <p>
                                Coverage is provided for the following breakdowns to your Interior Electric System and
                                Electric Vehicle Charger in your eligible residence.{' '}
                            </p>
                            <div className={styles.ratesTable}>
                                <BootstrapTable
                                    keyField='tierType'
                                    data={constellationData}
                                    columns={constellationColumns}
                                    bordered={true}
                                    bootstrap4
                                    wrapperClasses='table-responsive'
                                />
                            </div>
                            <p>
                                Coverage for the Interior Electric System includes standard interior copper wiring,
                                breaker panels/load centers, fuse boxes, fuses, circuit breakers, load management
                                devices, connectors, boxes, standard wall outlets/receptacles (including Ground Fault
                                Circuit Interrupters), and standard wall switches and dimmers.{' '}
                            </p>
                            <p>
                                Electric Vehicle Charger means the tier 2 charging device that you purchased from an
                                authorized seller.{' '}
                            </p>
                            <p>
                                Coverage is subject to detailed terms, conditions and exclusions. Please see the{' '}
                                <a
                                    href='/coveragedocs'
                                    target='blank'
                                >
                                    terms and conditions
                                </a>{' '}
                                for complete details.{' '}
                            </p>
                        </>
                    ]
                },
                {
                    question: 'Can I add any additional products or coverage?',
                    answer: 'No, you cannot add any additional products or coverage once a plan has been purchased.'
                },
                {
                    question: 'Can I cancel my active protection plan?',
                    answer: 'Yes, you may cancel your protection plan contract at any time for any reason by calling (888) 243-4663.'
                }
            ]
        },
        {
            title: 'Filing A Claim',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'When can a claim be filed?',
                    answer: [
                        <>
                            A claim can be filed on the coverage start date of the plan, which is the date your eligible
                            electric vehicle charger is installed at your property. Note the protection plan does not
                            cover any pre-existing conditions or failures that occur before the effective date. Please
                            see the
                            <a
                                href='/coveragedocs'
                                className='ml-1 mr-1'
                                target='blank'
                            >
                                terms and conditions
                            </a>
                            for complete details.
                        </>
                    ]
                },
                {
                    question: 'How is a claim filed?',
                    answer: 'If a covered incident occurs, you can use the online customer portal to easily file a claim and schedule service or call us toll-free at (833) 237-1002.'
                },
                {
                    question: 'Who will provide service?',
                    answer: 'If on-site service is required, we will dispatch your request to an authorized service provider in your area. Based on the servicer, you will either select a convenient time for service while filing your claim or the service provider will contact you within 24 hours to schedule an appointment.'
                },
                {
                    question: 'Once I submit a claim, how long will it take for me to get an appointment?',
                    answer: 'Based on your assigned service provider, you will either select a convenient time for service while filing your claim or the service provider will contact you within 24 hours to schedule an appointment. Most appointments will be scheduled during normal business hours. Once your claim is submitted, we will provide the servicer’s name and contact information. If you do not hear from your service provider within 24 hours, you can contact them directly.'
                },
                {
                    question: 'What will happen when the service provider arrives at my home?',
                    answer: 'After the authorized servicer arrives at your home, they will diagnose the problem. If necessary, they will call the Constellation Authorization Department to determine coverage and obtain authorization to proceed with the repair or replacement. For many repairs, the authorized servicer will be able to complete the service request while at your home.'
                },
                {
                    question: 'How long will it take for equipment or parts to arrive?',
                    answer: 'Any necessary equipment or parts may be ordered by our Purchasing Department or your service provider. The delivery time varies by availability and region. If there is a delay or shortage with your order, we will keep you posted along the way.'
                },
                {
                    question: 'What happens when the parts are delivered?',
                    answer: 'Once the covered equipment or parts are delivered, the authorized servicer will contact you to schedule an appointment and complete the service request.'
                },
                {
                    question:
                        'If my interior electric system or electric vehicle charger cannot be repaired, how will my claim be resolved?',
                    answer: [
                        <>
                            Our goal is to successfully resolve all valid claims, however a repair is not always
                            possible. In such situations, we may exchange your product with a replacement with similar
                            features and functionality or offer a buyout in the amount of the required repair or
                            service, up to the protection plan’s maximum annual limit. A replacement or buyout may be
                            less than the covered product’s original retail price. Please see our complete{' '}
                            <a
                                href='/coveragedocs'
                                target='blank'
                            >
                                terms and conditions
                            </a>{' '}
                            for more details.
                        </>
                    ]
                }
            ]
        }
    ],
    sibi: [
        {
            title: 'About Service Plans',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question:
                        'Once a Warranty Service Plan is purchased, how long will it take to receive the actual contract?',
                    answer: [
                        <>
                            <p>
                                If a valid email address is provided, we will send the Warranty Service Plan via email
                                within 7-14 business days (Monday-Friday) after purchase. If we do not have an email
                                address, we will send the Warranty Service Plan via United States Postal Service (USPS)
                                within 30 days after purchase.
                            </p>
                        </>
                    ]
                }
            ]
        },
        {
            title: 'Plan Options',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'What is covered in the Warranty Service Plan?',
                    answer: [
                        <>
                            <p>
                                All Service Plans provide coverage for structural or operational failures to your
                                purchased appliance due to defects in materials or workmanship. For eligible appliances,
                                your Service Plan may also provide coverage for failures caused by power surge. Your
                                Order Confirmation will indicate if your appliance is eligible for power surge.
                            </p>
                            <p>
                                Coverage is subject to detailed terms, conditions and exclusions. Please see the{' '}
                                <a
                                    href='/coveragedocs'
                                    target='blank'
                                >
                                    terms and conditions
                                </a>{' '}
                                for complete details.{' '}
                            </p>
                        </>
                    ]
                },
                {
                    question: 'Can I add any additional products or coverage?',
                    answer: 'No, you cannot add on any additional products or coverage once a plan has been purchased.'
                },
                {
                    question: 'Can I cancel my Warranty Service Plan once I have purchased it?',
                    answer: [
                        <p>
                            {' '}
                            Yes, you may cancel your Warranty Service Plan contract at any time for any reason. You may
                            cancel the plan by calling (866) 528-7034. Refund amounts may vary depending on the
                            cancellation date. Please see the{' '}
                            <a
                                href='/coveragedocs'
                                target='blank'
                            >
                                terms and conditions
                            </a>{' '}
                            for complete details.
                        </p>
                    ]
                }
            ]
        },
        {
            title: 'Filing A Claim',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'When can a claim be filed?',
                    answer: [
                        <>
                            A claim can be filed on the effective date of the Service Plan. Please note the Warranty
                            Service Plan does not cover any pre-existing conditions or failures that occur prior to the
                            effective date, nor will coverage be provided for products covered by a manufacturer’s
                            warranty. A claim must be filed within 30 days from the applicable failure and prior to your
                            Service Plan’s expiration to be eligible for coverage. See the
                            <a
                                href='/coveragedocs'
                                className='ml-1 mr-1'
                                target='blank'
                            >
                                {' '}
                                terms and conditions
                            </a>{' '}
                            for complete details.
                        </>
                    ]
                },
                {
                    question: 'How is a claim filed?',
                    answer: 'If a problem occurs, you can use this portal to easily file a claim and schedule service or call us toll-free at (866) 528-7034.'
                },
                {
                    question: 'Who will service the product?',
                    answer: 'We will dispatch your service request to an authorized service provider in your area. Based on the servicer, you will either select a convenient time for service while filing your claim or the service provider will contact you within 24 hours to schedule an appointment.'
                },
                {
                    question: 'Once I submit a claim, how long will it take for me to get an appointment?',
                    answer: 'Based on your assigned service provider, you will either select a convenient time for service while filing your claim or the service provider will contact you within 24 hours to schedule an appointment. Appointment times may vary and depend on your service provider’s availability and standard hours of operation. Once your claim is submitted, we will provide the servicer’s name and contact information. If you do not hear from your service provider within 24 hours you can contact them directly.'
                },
                {
                    question: 'What will happen when the service provider arrives at my home?',
                    answer: 'After the authorized servicer arrives at your home, they will diagnose the problem, and if necessary, call the Warranty Service Plan Authorization Department to determine coverage and obtain authorization to proceed with the repair or replacement. Keep in mind, for many repairs, the authorized servicer will be able to complete the service request while at your home.'
                },
                {
                    question: 'How long will it take for equipment or parts to arrive?',
                    answer: 'If covered equipment or parts are necessary to complete the repair or replacement, the equipment and/or parts may be ordered by either our Purchasing Department or your service provider. How long it will take varies by availability and region. If there is a delay or shortage with your order, we will keep you posted along the way.'
                },
                {
                    question: 'What happens when the parts are delivered?',
                    answer: 'Once the covered equipment or parts are delivered, the authorized servicer will contact you to schedule an appointment and complete the repair or installation.'
                },
                {
                    question: 'If my appliance or home system cannot be repaired, how will my claim be resolved?',
                    answer: [
                        <>
                            Our goal is to successfully resolve all valid claims. However, a repair is not always
                            possible. In such situations, we may either exchange your product with a replacement that
                            has similar features and functionality or offer a buyout up to the Warranty Service Plan's
                            eligible benefit limit for that product. Replacement or buyout may be less than the covered
                            product’s original retail price. Please see our complete{' '}
                            <a
                                href='/coveragedocs'
                                target='blank'
                            >
                                terms and conditions
                            </a>{' '}
                            for more details.
                        </>
                    ]
                }
            ]
        }
    ],
    homekick: [
        {
            title: 'About Home Warranty Plans',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'What is a home warranty plan?',
                    answer: [
                        <p>
                            A home warranty plan can help with repair costs for a covered product or home system if a
                            breakdown occurs. These interruptions can be unexpected and may be costly. With an Eversafe
                            Warranty plan, if a covered incident occurs, we will help repair or replace the product or
                            component to the plan’s maximum limit of liability. Please see the{' '}
                            <a
                                href='/coveragedocs'
                                target='blank'
                            >
                                terms and conditions
                            </a>{' '}
                            for complete details.
                        </p>
                    ]
                },
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question:
                        'Once an Eversafe Warranty Plan is purchased, how long will it take to receive the actual contract?',
                    answer: [
                        <p>
                            If a valid email address is provided, we will send the Eversafe Warranty Plan documents via
                            email within 7-14 business days from the date of purchase. If we do not have an email
                            address, we will send the Eversafe Warranty Plan documents via United States Postal Service
                            (USPS) within 30 days from the date of purchase.
                        </p>
                    ]
                }
            ]
        },
        {
            title: 'Plan Options',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'What is covered in the Buyer Plan?',
                    answer: [
                        <>
                            <div className={styles.homekickBuyerTable}>
                                <BootstrapTable
                                    keyField='tierType'
                                    data={homekickBuyerData}
                                    columns={homekickBuyerColumns}
                                    bordered={true}
                                    bootstrap4
                                    wrapperClasses='table-responsive'
                                />
                            </div>
                            <p>
                                If your residence has more than one of each type of appliance or system, we will only
                                cover the first appliance or system of that type for which you make a service call;
                                unless the coverage section specifically lists that more than one appliance or system
                                can be covered.
                            </p>
                            <p>
                                Coverage is subject to detailed terms, conditions and exclusions. Please see the{' '}
                                <a
                                    href='/coveragedocs'
                                    target='blank'
                                >
                                    terms and conditions
                                </a>{' '}
                                for complete details.
                            </p>
                        </>
                    ]
                },
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'What is covered in the Seller Plan?',
                    answer: [
                        <>
                            <div className={styles.homekickBuyerTable}>
                                <BootstrapTable
                                    keyField='tierType'
                                    data={homekickSellerData}
                                    columns={homekickBuyerColumns}
                                    bordered={true}
                                    bootstrap4
                                    wrapperClasses='table-responsive'
                                />
                            </div>
                            <p>
                                If your residence has more than one of each type of appliance or system, we will only
                                cover the first appliance or system of that type for which you make a service call;
                                unless the coverage section specifically lists that more than one appliance or system
                                can be covered.
                            </p>
                            <p>
                                Coverage is subject to detailed terms, conditions and exclusions. Please see the{' '}
                                <a
                                    href='/coveragedocs'
                                    target='blank'
                                >
                                    terms and conditions
                                </a>{' '}
                                for complete details.
                            </p>
                        </>
                    ]
                },
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'What is covered in the DTC Plan?',
                    answer: [
                        <>
                            <div className={styles.homekickBuyerTable}>
                                <BootstrapTable
                                    keyField='tierType'
                                    data={homekickDTCData}
                                    columns={homekickBuyerColumns}
                                    bordered={true}
                                    bootstrap4
                                    wrapperClasses='table-responsive'
                                />
                            </div>
                            <p>
                                If your residence has more than one of each type of appliance or system, we will only
                                cover the first appliance or system of that type for which you make a service call;
                                unless the coverage section specifically lists that more than one appliance or system
                                can be covered.
                            </p>
                            <p>
                                Coverage is subject to detailed terms, conditions and exclusions. Please see the{' '}
                                <a
                                    href='/coveragedocs'
                                    target='blank'
                                >
                                    terms and conditions
                                </a>{' '}
                                for complete details.
                            </p>
                        </>
                    ]
                },
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'Can I add additional coverage for any additional products?',
                    answer: [
                        <>
                            <p>
                                Yes, add-on coverage for additional products can be purchased at the time of the
                                original plan purchase or at any point during the coverage term. Depending on the type
                                of add-on plan purchased, a wait period may apply. A wait period is the time between the
                                date you purchased the coverage and the effective date of the coverage. If an add-on
                                coverage has a wait period, any losses that occur or take place during the wait period
                                are not eligible for coverage and a claim cannot be filed. Please note the plan does not
                                cover any pre-existing conditions or failures that occur prior to or during the wait
                                period. See the{' '}
                                <a
                                    href='/coveragedocs'
                                    target='blank'
                                >
                                    terms and conditions
                                </a>{' '}
                                for complete details.
                            </p>
                            <div className={styles.homekickBuyerTable}>
                                <BootstrapTable
                                    keyField='tierType'
                                    data={homekickAdditionalData}
                                    columns={homekickBuyerColumns}
                                    bordered={true}
                                    bootstrap4
                                    wrapperClasses='table-responsive'
                                />
                            </div>
                        </>
                    ]
                },
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'Can I cancel my Eversafe Warranty Plan once I have purchased it?',
                    answer: [
                        <>
                            <p>
                                Yes, you may cancel your Eversafe Warranty Plan at any time for any reason by calling
                                (866) 944-5425 Monday through Friday, 10 a.m.-10 p.m. EST. Refund amounts may vary
                                depending on the cancellation date. Please see the{' '}
                                <a
                                    href='/coveragedocs'
                                    target='blank'
                                >
                                    terms and conditions
                                </a>{' '}
                                for complete details.
                            </p>
                        </>
                    ]
                }
            ]
        },
        {
            title: 'Filing A Claim',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'When can a claim be filed?',
                    answer: [
                        <>
                            A claim can be filed on the effective date of the plan. Please reference the coverage
                            effective date listed within your Eversafe Warranty Plan documents. Please note the plan
                            does not cover any pre-existing conditions or failures that occur prior to the effective
                            date, nor will coverage be provided for products covered by a manufacturer’s warranty. A
                            claim must be filed within 30 days of the applicable failure and prior to your Eversafe
                            Warranty Plan’s expiration date to be eligible for coverage. If your plan has a wait period
                            (i.e., a time period between the date you purchased the plan and the effective date of the
                            plan), any losses that occur or take place during the wait period are not eligible for the
                            coverage and a claim cannot be filed. See the{' '}
                            <a
                                href='/coveragedocs'
                                className='ml-1 mr-1'
                                target='blank'
                            >
                                terms and conditions
                            </a>{' '}
                            for complete details.
                        </>
                    ]
                },
                {
                    question: 'How do I file a claim?',
                    answer: 'If a problem occurs, you can use this portal to easily file a claim and schedule service or call us toll-free at (866) 944-5425, Monday through Friday, 8 a.m. - 8 p.m. EST and Saturday 9 a.m. - 5 p.m. EST.'
                },
                {
                    question: 'Do I have to pay a trade service fee?',
                    answer: 'Yes, you must pay a trade service fee when you file a claim. The trade service fee amount for an Eversafe Warranty Plan is $100 per claim.'
                },
                {
                    question: 'What is a trade service fee?',
                    answer: [
                        <>
                            A trade service fee is a flat rate that must be paid when you file a claim. You must pay
                            this fee for each individual claim before we will initiate or provide services under the
                            Eversafe Warranty Plan. This fee is non-refundable if service is rendered, or payment has
                            been rendered via reimbursement. This fee will not be included in any calculation for
                            cash-out offers or reimbursements if a provider has been sent to the home and provided
                            service. The fee amount for an Eversafe Warranty plan is $100 per claim. This fee is
                            separate from any trip or diagnosis fees that may be counted towards your benefit limit for
                            covered repairs.
                        </>
                    ]
                },
                {
                    question: 'Will I pay a trade service fee for each servicer visit required for a single claim?',
                    answer: 'No, the trade service fee applies once per claim that is filed.'
                },
                {
                    question: 'When is the trade service fee paid?',
                    answer: [
                        <>
                            <p>
                                The trade service fee is due when you file a claim. The trade service fee will be
                                collected during claim setup and is separate from any trip or diagnosis fees that may be
                                counted towards your benefit limit for covered repairs. We accept Visa, MasterCard,
                                Discover or American Express in the form of a credit or debit card payment.
                            </p>

                            <p>
                                If you are filing a claim for more than one appliance or home system, a separate claim
                                and trade service fee will be required.
                            </p>
                        </>
                    ]
                },
                {
                    question: 'Who will service the product?',
                    answer: 'We will dispatch your service request to an authorized service provider in your area. Based on the servicer, you will either select a convenient time for service while filing your claim or the service provider will contact you within 24 hours to schedule an appointment.'
                },
                {
                    question: 'Once I submit a claim, how long will it take to get a service appointment?',
                    answer: 'Based on your assigned service provider, you will either select a convenient time for service while filing your claim or the service provider will contact you within 24 hours to schedule an appointment. Most appointments will be scheduled during normal business hours. Once your claim is submitted, we will provide the servicer’s name and contact information. If you do not hear from your service provider within 24 hours you can contact them directly.'
                },
                {
                    question: 'What will happen when the service provider arrives at my home?',
                    answer: [
                        <>
                            After the authorized servicer arrives at your home, they will diagnose the problem, and if
                            necessary, call the Eversafe Warranty Plan Authorization Department to determine coverage
                            and obtain authorization to proceed with the repair or replacement. Keep in mind, for many
                            repairs, the authorized servicer will be able to complete the service request while at your
                            home.
                        </>
                    ]
                },
                {
                    question: 'How long will it take for equipment or parts to arrive?',
                    answer: 'If covered equipment or parts are necessary to complete the repair or replacement, the equipment and/or parts may be ordered by either our Purchasing Department or your service provider. How long it will take varies by availability and region. If there is a delay or shortage with your order, we will keep you posted along the way.'
                },
                {
                    question: 'What happens when the parts are delivered?',
                    answer: 'Once the covered equipment or parts are delivered, the authorized servicer will contact you to schedule an appointment and complete the repair or installation.'
                },
                {
                    question: 'If my appliance or home system cannot be repaired, how will my claim be resolved?',
                    answer: [
                        <>
                            Our goal is to successfully resolve all valid claims. However, a repair is not always
                            possible. In such situations, we may either exchange your product with a replacement that
                            has similar features and functionality or offer a cash settlement or replacement allowance
                            up to the Eversafe Warranty Plan eligible benefit limit for that product and subject to the
                            plan’s aggregate limit. Replacement products or cash settlements/replacement allowances may
                            be less than the covered product’s original retail price. Please see the complete{' '}
                            <a
                                href='/coveragedocs'
                                target='blank'
                            >
                                terms and conditions
                            </a>{' '}
                            for more details.
                        </>
                    ]
                }
            ]
        }
    ],
    rate: [
        {
            title: 'About Home Warranty Plans',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'What is a home warranty plan?',
                    answer: [
                        <>
                            A home warranty plan can help with repair costs for a covered product or home system if a
                            breakdown occurs. These interruptions can be unexpected and may be costly. With a Rate Whole
                            Home Warranty plan, if a covered incident occurs, we will help repair or replace the product
                            or component to the plan’s maximum limit of liability. Please see the
                            <a
                                href='/coveragedocs'
                                className='ml-1 mr-1'
                                target='blank'
                            >
                                terms and conditions
                            </a>
                            for more details.
                        </>
                    ]
                },
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question:
                        'Once a Rate Whole Home Warranty plan is purchased, how long will it take to receive the actual contract?',
                    answer: 'If a valid email address is provided, we will send the Rate Whole Home Warranty plan documents via email within 7-14 business days from the date of purchase. If we do not have an email address, we will send the Rate Whole Home Warranty plan documents via United States Postal Service (USPS) within 30 days from the date of purchase.'
                }
            ]
        },
        {
            title: 'Plan Options',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'What is covered in the Rate Whole Home Warranty plan?',
                    answer: [
                        <>
                            <div className={styles.homekickBuyerTable}>
                                <BootstrapTable
                                    keyField='tierType'
                                    data={homekickBuyerData}
                                    columns={homekickBuyerColumns}
                                    bordered={true}
                                    bootstrap4
                                    wrapperClasses='table-responsive'
                                />
                            </div>
                            <p>
                                If your residence has more than one of each type of appliance or system, we will only
                                cover the first appliance or system of that type for which you make a service call;
                                unless the coverage section specifically lists that more than one appliance or system
                                can be covered.
                            </p>
                            <p>
                                Coverage is subject to detailed terms, conditions, and exclusions. Please see the{' '}
                                <a
                                    href='/coveragedocs'
                                    target='blank'
                                >
                                    terms and conditions
                                </a>{' '}
                                for complete details.
                            </p>
                        </>
                    ]
                },
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'Can I cancel my Rate Whole Home Warranty plan once I have purchased it?',
                    answer: [
                        <>
                            <p>
                                Yes, you may cancel your Rate Whole Home Warranty plan at any time for any reason by
                                calling <ClientPhone type='sales' />. Refund amounts may vary depending on the
                                cancellation date. Please see the
                                <a
                                    href='/coveragedocs'
                                    className='ml-1 mr-1'
                                    target='blank'
                                >
                                    terms and conditions
                                </a>{' '}
                                for complete details.
                            </p>
                        </>
                    ]
                }
            ]
        },
        {
            title: 'Filing A Claim',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'When can a claim be filed?',
                    answer: [
                        <>
                            A claim can be filed on the effective date of the plan. Please reference the coverage
                            effective date listed within your Rate Whole Home Warranty plan documents. Please note the
                            plan does not cover any pre-existing conditions or failures that occur prior to the
                            effective date, nor will coverage be provided for products covered by a manufacturer’s
                            warranty. A claim must be filed within 30 days of the applicable failure and prior to your
                            Rate Whole Home Warranty plan’s expiration date to be eligible for coverage. If your plan
                            has a wait period (i.e., a time period between the date you purchased the plan and the
                            effective date of the plan), any losses that occur or take place during the wait period are
                            not eligible for the coverage, and a claim cannot be filed. See the
                            <a
                                href='/coveragedocs'
                                className='ml-1 mr-1'
                                target='blank'
                            >
                                terms and conditions
                            </a>{' '}
                            for complete details.
                        </>
                    ]
                },
                {
                    question: 'How do I file a claim?',
                    answer: 'If a problem occurs, you can use this portal to easily file a claim and schedule service or call us toll-free at  (833) 778-4727, Monday through Friday, 8 a.m. - 8 p.m. EST and Saturday 9 a.m. - 5 p.m. EST.'
                },
                {
                    question: 'Do I have to pay a trade service fee?',
                    answer: [
                        <>
                            Yes, you must pay a trade service fee when you file a claim. The trade service fee amount
                            for a Rate Whole Home Warranty plan is $150 per claim.
                        </>
                    ]
                },
                {
                    question: 'What is a trade service fee?',
                    answer: 'A trade service fee is a flat rate that must be paid when you file a claim. You must pay this fee for each individual claim before we will initiate or provide services under the Rate Whole Home Warranty plan. This fee is non-refundable if service is rendered, or payment has been rendered via reimbursement. This fee will not be included in any calculation for cash-out offers or reimbursements if a provider has been sent to the home and provided service. The fee amount for a Rate Whole Home Warranty plan is $150 per claim. This fee is separate from any trip or diagnosis fees that may be counted towards your benefit limit for covered repairs.'
                },
                {
                    question: 'Will I pay a trade service fee for each servicer visit required for a single claim?',
                    answer: 'No, the trade service fee is only applied once for each claim that is filed.'
                },
                {
                    question: 'When is the trade service fee paid?',
                    answer: [
                        <>
                            <p>
                                The trade service fee is due when you file a claim. The service fee will be collected
                                during claim setup and is separate from any trip or diagnosis fees that may be counted
                                towards your benefit limit for covered repairs. We accept Visa, MasterCard, Discover or
                                American Express in the form of a credit or debit card payment.
                            </p>
                            <p>
                                If you are filing a claim for more than one appliance or home system, a separate claim
                                and trade service fee will be required.
                            </p>
                        </>
                    ]
                },
                {
                    question: 'Who will service the product?',
                    answer: 'We will dispatch your service request to an authorized service provider in your area. Based on the servicer, you will either select a convenient time for service while filing your claim or the service provider will contact you within 24 hours to schedule an appointment.'
                },
                {
                    question: 'Once I submit a claim, how long will it take to get a service appointment?',
                    answer: 'Based on your assigned service provider, you will either select a convenient time for service while filing your claim or the service provider will contact you within 24 hours to schedule an appointment. Most appointments will be scheduled during normal business hours. Once your claim is submitted, we will provide the servicer’s name and contact information. If you do not hear from your service provider within 24 hours you can contact them directly.'
                },
                {
                    question: 'What will happen when the service provider arrives at my home?',
                    answer: 'After the authorized servicer arrives at your home, they will diagnose the problem, and if necessary, call the Rate Whole Home Warranty Authorization Department to determine coverage and obtain authorization to proceed with the repair or replacement. Keep in mind, for many repairs, the authorized servicer will be able to complete the service request while at your home.'
                },
                {
                    question: 'How long will it take for equipment or parts to arrive?',
                    answer: 'If covered equipment or parts are necessary to complete the repair or replacement, the equipment and/or parts may be ordered by either our Purchasing Department or your service provider. How long it will take varies by availability and region. If there is a delay or shortage with your order, we will keep you posted along the way.'
                },
                {
                    question: 'What happens when the parts are delivered?',
                    answer: 'Once the covered equipment or parts are delivered, the authorized servicer will contact you to schedule an appointment and complete the repair or installation.'
                },
                {
                    question: 'If my appliance or home system cannot be repaired, how will my claim be resolved?',
                    answer: [
                        <>
                            Our goal is to successfully resolve all valid claims. However, a repair is not always
                            possible. In such situations, we may either exchange your product with a replacement that
                            has similar features and functionality or offer a cash settlement or replacement allowance
                            subject to your remaining limit of liability minus any prior claims paid. Replacement
                            products or cash settlements/replacement allowances may be less than the covered product’s
                            original retail price. Please see the complete
                            <a
                                href='/coveragedocs'
                                className='ml-1 mr-1'
                                target='blank'
                            >
                                terms and conditions
                            </a>
                            for more details.
                        </>
                    ]
                }
            ]
        }
    ],
    flex: [
        {
            title: 'About Service Plans',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'What is a Service Plan?',
                    answer: [
                        <>
                            A service plan can help with repair costs for a covered product if a covered breakdown
                            occurs. These interruptions can be unexpected and may be costly. With a Flex Protect Service
                            Plan, if a covered breakdown occurs, we will help repair or replace the product or component
                            to the plan’s maximum limit of liability. Please see the
                            <a
                                href='/coveragedocs'
                                className='ml-1 mr-1'
                                target='blank'
                            >
                                terms and conditions
                            </a>
                            for more details.
                        </>
                    ]
                },
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question:
                        'Once a Flex Protect Service Plan is purchased, how long will it take to receive the actual contract?',
                    answer: 'If a valid email address is provided, we will send the Flex Protect plan documents via email within 7-14 business days from the date of purchase.'
                }
            ]
        },
        {
            title: 'Plan Options',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'What is covered by the plan?',
                    answer: [
                        <>
                            <p>
                                The plan will provide repair, replacement or reimbursement services if a covered
                                breakdown occurs on the covered Product. Please refer to your Flex Protect plan
                                documents for a list of covered products and breakdowns. Depending on the plan, covered
                                breakdowns may include mechanical and electrical failures, power surge or accidental
                                damage from handling (ADH).
                            </p>
                            <p>
                                Coverage is subject to detailed terms, conditions and exclusions. Please see the
                                <a
                                    href='/coveragedocs'
                                    target='blank'
                                    className='ml-1 mr-1'
                                >
                                    terms and conditions
                                </a>
                                for complete details.
                            </p>
                        </>
                    ]
                },
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'Can I add coverage for any additional products?',
                    answer: 'No, you cannot add any additional products or coverage once a plan has been purchased. If you would like coverage on another product, you can purchase a separate plan on that product.'
                },
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'Can I cancel my Flex Protect Service Plan once I have purchased it?',
                    answer: [
                        <>
                            <p>
                                Yes, you may cancel your Flex Protect Service Plan at any time for any reason by
                                visiting{' '}
                                <a
                                    href='https://www.flexconnect.ai'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    www.flexconnect.ai
                                </a>{' '}
                                or by calling 1 (800) 235-3545. Refund amounts may vary depending on the cancellation
                                date. Please see the{' '}
                                <a
                                    href='/coveragedocs'
                                    target='blank'
                                >
                                    terms and conditions
                                </a>{' '}
                                for complete details.
                            </p>
                        </>
                    ]
                }
            ]
        },
        {
            title: 'Filing A Claim',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'When can a claim be filed?',
                    answer: [
                        <>
                            A claim can be filed on the coverage start date of the plan. Please reference the coverage
                            start date listed within your Flex Protect Service Plan documents. Please note the plan does
                            not cover any pre-existing conditions or failures that occur prior to the effective date,
                            nor will coverage be provided for products covered by a manufacturer’s warranty. A claim
                            must be filed within 30 days of the applicable failure and prior to your Flex Protect
                            Service Plan’s expiration date to be eligible for coverage. If your plan has a wait period
                            (i.e., a time period between the date you purchased the plan and the coverage start date of
                            the plan), any losses that occur or take place during the wait period are not eligible for
                            the coverage and a claim cannot be filed. See the
                            <a
                                href='/coveragedocs'
                                className='ml-1 mr-1'
                                target='blank'
                            >
                                terms and conditions
                            </a>{' '}
                            for complete details.
                        </>
                    ]
                },
                {
                    question: 'How do I file a claim?',
                    answer: 'If a problem occurs, you can use this portal to easily file a claim and schedule service or call us toll-free at (800) 235-3545, Monday through Friday, 8 a.m. - 8 p.m. EST and Saturday 9 a.m. - 5 p.m. EST.'
                },
                {
                    question: 'Do I have to pay a service fee?',
                    answer: 'Service fees are only applicable on specific products. Please refer to your Flex Protect Service Plan Order Confirmation to determine if a Service Fee applies to your plan.'
                },
                {
                    question: 'What is a service fee?',
                    answer: 'If a service fee applies, it is a flat rate that must be paid when you file a claim. You must pay this fee for each individual claim before we will initiate or provide services under the Flex Protect Service Plan. This fee is non-refundable if service is rendered, or payment has been rendered via reimbursement. This fee will not be included in any calculation for cash-out offers or reimbursements if a provider has been sent to the home and provided service. The fee amount for a Flex Protect Service Plan is listed on the Flex Protect Service Plan Order Confirmation. This fee is separate from any trip or diagnosis fees that may be counted towards your benefit limit for covered repairs.'
                },
                {
                    question: 'Will I pay a service fee for each servicer visit required for a single claim?',
                    answer: 'No, if a service fee is applicable, the fee applies once per claim that is filed.'
                },
                {
                    question: 'When is the service fee paid?',
                    answer: 'If a service fee applies, it is due when you file a claim. The service fee will be collected during claim setup and is separate from any trip or diagnosis fees that may be counted towards your benefit limit for covered repairs. We accept Visa, MasterCard, Discover or American Express in the form of a credit or debit card payment.'
                },
                {
                    question: 'Who will service the product?',
                    answer: 'Depending on your product we will either dispatch service to an authorized service provider in your area, mail you a box and shipping label to ship your product to a repair depot or offer you reimbursement or replacement.'
                },
                {
                    question: 'Once I submit a claim, how long will it take for my product to be repaired or replaced?',
                    answer: [
                        <>
                            <p>Depending on your product, we will offer you one of the following service options:</p>
                            <p>
                                For Onsite Service: Based on your assigned service provider, you will either select a
                                convenient time for service while filing your claim or the service provider will contact
                                you within 24 hours to schedule an appointment. Most appointments will be scheduled
                                during normal business hours. Once your claim is submitted, we will provide the
                                servicer’s name and contact information. If you do not hear from your service provider
                                within 24 hours you can contact them directly.
                            </p>
                            <p>
                                For Depot Repairs: Once your claim is submitted and approved, we will provide the repair
                                depot’s name, contact information and a timeframe that you should receive a box and
                                shipping label to send the product in for repair.
                            </p>
                            <p>
                                For Reimbursement: Once your claim is submitted and approved, we will issue a
                                reimbursement within 7 to 14 business days for the product retail price indicated on the
                                sales receipt or confirmation, less any taxes, applicable discounts and installation
                                fees.
                            </p>
                            <p>
                                For Carry-In Service: Carry-In Service. We may request to have Your Covered Product
                                repaired at a nearby facility of Our choosing. You will be responsible for transporting
                                Your Covered Product to and from the nearby repair facility.
                            </p>
                        </>
                    ]
                },
                {
                    question: 'What will happen when the service provider arrives at my home?',
                    answer: 'After the authorized servicer arrives at your home, they will diagnose the problem, and if necessary, call the Flex Protect Authorization Department to determine coverage and obtain authorization to proceed with the repair or replacement. Keep in mind, for many repairs, the authorized servicer will be able to complete the service request while at your home.'
                },
                {
                    question: 'How long will it take for equipment or parts to arrive?',
                    answer: 'If covered equipment or parts are necessary to complete the repair or replacement, the equipment and/or parts may be ordered by either our Purchasing Department or your service provider. How long it will take varies by availability and region. If there is a delay or shortage with your order, we will keep you posted along the way.'
                },
                {
                    question: 'What happens when the parts are delivered?',
                    answer: 'Once the covered equipment or parts are delivered, the authorized servicer will contact you to schedule an appointment and complete the repair or installation.'
                },
                {
                    question:
                        'For depot repairs, how long will it take to receive the box and shipping label to send my product in for repair?',
                    answer: 'The repair depot will send you a box and shipping label via ground service which typically takes 1 to 5 business days. If your claim is submitted prior to 2 p.m. EST, the box and label will be shipped the same day. If submitted after 2 p.m. EST, it will ship the next business day.'
                },
                {
                    question: 'For depot repairs, what if I do not receive my box and shipping label?',
                    answer: 'If you do not receive a box and shipping label within 5 business days, you can contact the repair depot directly. After your claim is submitted, we will provide the repair depot’s name and contact information.'
                },
                {
                    question: 'For depot repairs, how long do I have to drop off my product at the shipping facility?',
                    answer: 'The product should be dropped off to the shipping facility within 15 days of receiving the box and shipping label. Failure to ship the product within 15 days may result in your claim being closed due to inactivity.'
                },
                {
                    question: 'If my product cannot be repaired, how will my claim be resolved?',
                    answer: [
                        <>
                            Our goal is to successfully resolve all valid claims. However, a repair is not always
                            possible. In such situations, we may either offer a replacement or reimbursement of the
                            purchase price of the product, less taxes, any applicable discounts, and installation fees,
                            and subject to the Flex Protect Service Plan eligible benefit limit for that product. Please
                            see the complete
                            <a
                                href='/coveragedocs'
                                className='ml-1 mr-1'
                                target='blank'
                            >
                                terms and conditions
                            </a>{' '}
                            for more details.
                        </>
                    ]
                }
            ]
        }
    ],
    aig: [
        {
            title: '',
            faqs: [
                {
                    question: '',
                    answer: ''
                }
            ]
        }
    ],
    sure: [
        {
            title: 'About Sure Home Warranty Plans',
            faqs: [
                {
                    question: 'What is a Sure Home Warranty Plan?',
                    answer: [
                        <p>
                            A home warranty plan can help with repair costs for a covered product or home system if a
                            breakdown occurs. These interruptions can be unexpected and may be costly. With a Sure Home
                            Warranty Plan, if a covered incident occurs, we will help repair or replace the product or
                            component to the plan’s maximum limit of liability. Please see the
                            <a
                                href='/coveragedocs'
                                target='blank'
                                className='ml-1 mr-1'
                            >
                                terms and conditions
                            </a>
                            for complete details.
                        </p>
                    ]
                }
            ]
        },
        {
            title: 'Plan Options',
            faqs: [
                {
                    question: 'What is covered in the Sure Home Warranty Plan?',
                    answer: [
                        <>
                            <div className={styles.homekickBuyerTable}>
                                <BootstrapTable
                                    keyField='tierType'
                                    data={sureBuyerData}
                                    columns={sureBuyerColumns}
                                    bordered={true}
                                    bootstrap4
                                    wrapperClasses='table-responsive'
                                />
                            </div>
                            <p>
                                If your residence has more than one of each type of appliance or system, we will only
                                cover the first appliance or system of that type for which you make a service call;
                                unless the coverage section specifically lists that more than one appliance or system
                                can be covered.
                            </p>
                            <p>
                                Coverage is subject to detailed terms, conditions and exclusions. Please see the
                                <a
                                    href='/coveragedocs'
                                    target='blank'
                                    className='ml-1 mr-1'
                                >
                                    terms and conditions
                                </a>
                                for complete details.
                            </p>
                        </>
                    ]
                },
                {
                    question: 'Can I add coverage for any additional products?',
                    answer: [
                        <>
                            <p>
                                Yes, add-on coverage for additional products can be purchased at the time of the
                                original plan purchase or at any point during the coverage term.
                            </p>
                            <p>
                                For a real estate transaction, if the add-on coverage is purchased within 30 days of the
                                original plan purchase, no wait period applies. If the add-on coverage is purchased 31
                                days or later, then a 30-day wait period applies.
                            </p>
                            <p>
                                For add-on coverage purchases outside a real estate transaction, a 30-day wait period
                                applies regardless of the purchase date.
                            </p>
                            <p>
                                WAIT PERIOD: A wait period is the time between the date you purchased the coverage and
                                the effective date of the coverage. If an add-on coverage has a wait period, any losses
                                that occur or take place during the wait period are not eligible for coverage and a
                                claim cannot be filed. See the
                                <a
                                    href='/coveragedocs'
                                    target='blank'
                                    className='ml-1 mr-1'
                                >
                                    terms and conditions
                                </a>
                                for complete details.
                            </p>
                            <p>
                                Please note the plan does not cover any pre-existing conditions or failures that occur
                                prior to or during the wait period. Available add-on products include:
                            </p>
                            <div className={styles.homekickBuyerTable}>
                                <BootstrapTable
                                    keyField='tierType'
                                    data={sureSellerData}
                                    columns={sureSellerColumns}
                                    bordered={true}
                                    bootstrap4
                                    wrapperClasses='table-responsive'
                                />
                            </div>
                        </>
                    ]
                },
                {
                    question: 'Can I cancel my Sure Home Warranty Plan once I have purchased it?',
                    answer: [
                        <>
                            <p>
                                Yes, you may cancel your Sure Home Warranty Plan at any time for any reason by calling{' '}
                                <ClientPhone
                                    className='ml-1'
                                    type='sales'
                                />
                                . Refund amounts may vary depending on the cancellation date. Please see the
                                <a
                                    href='/coveragedocs'
                                    target='blank'
                                    className='ml-1 mr-1'
                                >
                                    terms and conditions
                                </a>
                                for complete details.
                            </p>
                        </>
                    ]
                }
            ]
        },
        {
            title: 'Filing A Claim',
            faqs: [
                {
                    question: 'When can a claim be filed?',
                    answer: [
                        <>
                            A claim can be filed on the effective date of the plan. Please reference the coverage
                            effective date listed within your Sure Home Warranty plan documents. Please note the plan
                            does not cover any pre-existing conditions or failures that occur prior to the effective
                            date, nor will coverage be provided for products covered by a manufacturer’s warranty. A
                            claim must be filed within 30 days of the applicable failure and prior to your Sure Home
                            Warranty Plan’s expiration date to be eligible for coverage. If your plan has a wait period
                            (i.e., a time period between the date you purchased the plan and the effective date of the
                            plan), any losses that occur or take place during the wait period are not eligible for the
                            coverage and a claim cannot be filed. See the
                            <a
                                href='/coveragedocs'
                                className='ml-1 mr-1'
                                target='blank'
                            >
                                terms and conditions
                            </a>
                            for complete details.
                        </>
                    ]
                },
                {
                    question: 'How do I file a claim?',
                    answer: [
                        <>
                            If a problem occurs, you can use this portal to easily file a claim and schedule service or
                            call us toll-free at <ClientPhone />, Monday through Friday, 8 a.m. - 8 p.m. EST and
                            Saturday 9 a.m. - 5 p.m. EST.
                        </>
                    ]
                },
                {
                    question: 'Do I have to pay a trade service fee?',
                    answer: 'Yes, you must pay a trade service fee when you file a claim. The trade service fee amount for a Sure Home Warranty Plan is $100 per claim.'
                },
                {
                    question: 'What is a trade service fee?',
                    answer: [
                        <>
                            A trade service fee is a flat rate that must be paid when you file a claim. You must pay
                            this fee for each individual claim before we will initiate or provide services under the
                            Sure Home Warranty Plan. This fee is non-refundable if service is rendered, or payment has
                            been rendered via reimbursement. This fee will not be included in any calculation for
                            cash-out offers or reimbursements if a provider has been sent to the home and provided
                            service. The fee amount for a Sure Home Warranty Plan is $100 per claim. This fee is
                            separate from any trip or diagnosis fees that may be counted towards your benefit limit for
                            covered repairs.
                        </>
                    ]
                },
                {
                    question: 'Will I pay a trade service fee for each servicer visit required for a single claim?',
                    answer: 'No, the trade service fee is only applied once for each claim that is filed.'
                },
                {
                    question: 'When is the trade service fee paid?',
                    answer: [
                        <>
                            <p>
                                The trade service fee is due when you file a claim. The service fee will be collected
                                during claim setup and is separate from any trip or diagnosis fees that may be counted
                                towards your benefit limit for covered repairs. We accept Visa, MasterCard, Discover or
                                American Express in the form of a credit or debit card payment.
                            </p>

                            <p>
                                If you are filing a claim for more than one appliance or home system, a separate claim
                                and trade service fee will be required.
                            </p>
                        </>
                    ]
                },
                {
                    question: 'Who will service the product?',
                    answer: 'We will dispatch your service request to an authorized service provider in your area. Based on the servicer, you will either select a convenient time for service while filing your claim or the service provider will contact you within 24 hours to schedule an appointment.'
                },
                {
                    question: 'Once I submit a claim, how long will it take to get a service appointment?',
                    answer: [
                        <p>
                            Based on your assigned service provider, you will either select a convenient time for
                            service while filing your claim or the service provider will contact you within 24 hours to
                            schedule an appointment. Most appointments will be scheduled during normal business hours.
                            Once your claim is submitted, we will provide the servicer’s name and contact information.
                            If you do not hear from your service provider within 24 hours you can contact them directly.
                        </p>
                    ]
                },
                {
                    question: 'What will happen when the service provider arrives at my home?',
                    answer: [
                        <>
                            After the authorized servicer arrives at your home, they will diagnose the problem, and if
                            necessary, call the Sure Home Warranty Plan Authorization Department to determine coverage
                            and obtain authorization to proceed with the repair or replacement. Keep in mind, for many
                            repairs, the authorized servicer will be able to complete the service request while at your
                            home.
                        </>
                    ]
                },
                {
                    question: 'How long will it take for equipment or parts to arrive?',
                    answer: 'If covered equipment or parts are necessary to complete the repair or replacement, the equipment and/or parts may be ordered by either our Purchasing Department or your service provider. How long it will take varies by availability and region. If there is a delay or shortage with your order, we will keep you posted along the way.'
                },
                {
                    question: 'What happens when the parts are delivered?',
                    answer: 'Once the covered equipment or parts are delivered, the authorized servicer will contact you to schedule an appointment and complete the repair or installation.'
                },
                {
                    question: 'If my appliance or home system cannot be repaired, how will my claim be resolved?',
                    answer: [
                        <>
                            Our goal is to successfully resolve all valid claims. However, a repair is not always
                            possible. In such situations, we may either exchange your product with a replacement that
                            has similar features and functionality or offer a cash settlement or replacement allowance
                            subject to your remaining limit of liability minus any prior claims paid. Replacement
                            products or cash settlements/replacement allowances may be less than the covered product’s
                            original retail price. Please see the complete
                            <a
                                href='/coveragedocs'
                                target='blank'
                                className='ml-1 mr-1'
                            >
                                terms and conditions
                            </a>
                            for more details.
                        </>
                    ]
                }
            ]
        }
    ]

    // ONLY FOR TESTING. YOU KNOW, HAVE SOME FUN! 😁🎈
    // aig: [
    //     {
    //         title: 'Lorems',
    //         faqs: [
    //             {
    //                 question: 'Bacon Ipsum?',
    //                 // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
    //                 answer: [
    //                     "Bacon ipsum dolor amet kielbasa t-bone tail kevin. Brisket do tempor ball tip jowl. Est tongue capicola enim eu pork chop burgdoggen. Flank dolor cow fugiat et corned beef ad sed kevin pastrami sirloin shoulder. In ground round buffalo, nulla spare ribs et commodo. Ut ham hock ut irure ipsum occaecat.",
    //                     "Bacon ipsum dolor amet andouille tenderloin ground round pork belly, shank swine kevin. Chuck turducken cow burgdoggen kevin pancetta corned beef landjaeger tenderloin tail. Rump venison shankle chicken. Meatball sirloin meatloaf, doner leberkas bresaola boudin cupim. Leberkas sausage pork loin prosciutto beef burgdoggen kevin. Chislic biltong pork belly short ribs."
    //                 ]
    //             },
    //             {
    //                 question: 'Cheese Ipsum?',
    //                 answer: "I love cheese, especially cheeseburger fondue. Jarlsberg cheesy feet jarlsberg goat manchego cheesy feet airedale babybel. Cream cheese boursin cheesecake cheese and wine cheesy feet pecorino cottage cheese croque monsieur. Manchego goat emmental fromage mascarpone croque monsieur mascarpone cheesecake. Cheesy feet."
    //             },
    //             {
    //                 question: 'Coffee Ipsum?',
    //                 answer: 'Dripper, macchiato, spoon caramelization doppio plunger pot beans cream. So, latte saucer, cup froth rich con panna latte con panna bar  extraction. Wings eu coffee, and filter foam seasonal aromatic. Grinder eu, dripper chicory, iced wings turkish sit seasonal. Carajillo iced seasonal turkish black eu redeye, frappuccino cup half and half wings strong.'
    //             },
    //             {
    //                 question: 'Pikachu Ipsum?',
    //                 answer: 'Pikachu ipsum dolor sit amet jolteon quis articuno seaking ivysaur, eevee labore. Anim fugiat shellder tempor aute dolore. Ut dolore hypno excepteur proident. Laboris do dragonite dolore eiusmod. '
    //             }
    //         ]
    //     },
    //     {
    //         title: 'Hedgehogs',
    //         faqs: [
    //             {
    //                 question: 'Are all hedgehogs fast?',
    //                 answer: 'Some might say supersonic',
    //             },
    //             {
    //                 question: 'Are there any blue hedgehogs?',
    //                 answer: 'While some hedgehogs are allegedly blue, many in the the larger hedgehog community dislikes the assumption that they should also be blue'
    //             },
    //             {
    //                 question: 'Do hedgehogs like hedges? And are they related to other hogs?',
    //                 answer: 'No.'
    //             }
    //         ]
    //     }
    // ],
};
